import {type IUseSearchComboboxResult, SearchComboboxEmptyState, type SearchComboboxMode} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import {PRICES_SEARCH_COPY} from "../../constants/prices_search";
import type {IPricesSearchEmptyState} from "../../types/IPricesSearchModel";

interface IProps {
    empty: IPricesSearchEmptyState;
    combobox: Pick<IUseSearchComboboxResult, "getOptionProps">;
    mode: SearchComboboxMode;
}

/**
 * No results, or a known city without a prices page ("Nie mamy jeszcze cen dla „Radom”"); both end
 * with the popular cities as chips. The mobile layer uses the compact variant with wrapped chips.
 */
export const PricesSearchEmpty = (props: IProps) => {
    const {empty, combobox, mode} = props;
    const isCityWithoutData = empty.variant === "cityWithoutData" && empty.cityName !== undefined;

    return (
        <SearchComboboxEmptyState
            title={isCityWithoutData ? PRICES_SEARCH_COPY.cityWithoutDataTitle(empty.cityName ?? "") : PRICES_SEARCH_COPY.noResultsTitle(empty.query)}
            hint={isCityWithoutData ? PRICES_SEARCH_COPY.cityWithoutDataHint : PRICES_SEARCH_COPY.noResultsHint}
            chipsLabel={PRICES_SEARCH_COPY.popularChipsLabel}
            chips={empty.chips.map((chip) => ({
                key: chip.id,
                label: chip.label,
                ...combobox.getOptionProps(chip.id),
                dataTestId: PRICES_SEARCH_TEST_IDS.EMPTY_CHIP
            }))}
            compact={mode === "layer"}
            dataTestId={PRICES_SEARCH_TEST_IDS.EMPTY}
        />
    );
};
import {type IUseSearchComboboxResult, SearchComboboxEmptyState, type SearchComboboxMode} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import {PRICES_SEARCH_COPY} from "../../constants/prices_search";
import type {IPricesSearchEmptyState} from "../../types/IPricesSearchModel";

interface IProps {
    empty: IPricesSearchEmptyState;
    combobox: Pick<IUseSearchComboboxResult, "getOptionProps">;
    mode: SearchComboboxMode;
}

/**
 * No results, or a known city without a prices page ("Nie mamy jeszcze cen dla „Radom”"); both end
 * with the popular cities as chips. The mobile layer uses the compact variant with wrapped chips.
 */
export const PricesSearchEmpty = (props: IProps) => {
    const {empty, combobox, mode} = props;
    const isCityWithoutData = empty.variant === "cityWithoutData" && empty.cityName !== undefined;

    return (
        <SearchComboboxEmptyState
            title={isCityWithoutData ? PRICES_SEARCH_COPY.cityWithoutDataTitle(empty.cityName ?? "") : PRICES_SEARCH_COPY.noResultsTitle(empty.query)}
            hint={isCityWithoutData ? PRICES_SEARCH_COPY.cityWithoutDataHint : PRICES_SEARCH_COPY.noResultsHint}
            chipsLabel={PRICES_SEARCH_COPY.popularChipsLabel}
            chips={empty.chips.map((chip) => ({
                key: chip.id,
                label: chip.label,
                ...combobox.getOptionProps(chip.id),
                dataTestId: PRICES_SEARCH_TEST_IDS.EMPTY_CHIP
            }))}
            compact={mode === "layer"}
            dataTestId={PRICES_SEARCH_TEST_IDS.EMPTY}
        />
    );
};
